(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Qsched_type', Qsched_type);

    Qsched_type.$inject = ['$resource'];

    function Qsched_type ($resource) {
        var resourceUrl =  'api/qsched-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
